var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[(!_vm.isAuthenticated)?_c('UnAuthenticatedHeader',{attrs:{"links":_vm.links}}):_vm._e(),(_vm.isAuthenticated)?_c('ProfileHeader',{attrs:{"links":_vm.links}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }